import { styled } from "@mui/material"

export const Container = styled("div")({
  display: "flex",
  cursor: "pointer",
  justifyContent: "space-between",
  alignItems: "center",
  position: "relative",
  width: "23.5rem",
  height: "8rem",
  background: "#FFFFFF",
  padding: "0.7rem",
  borderRadius: "0.7rem",
  boxShadow:
    "0px 3px 3px rgba(160, 160, 160, 0.14), 0px 3px 4px rgba(160, 160, 160, 0.12), 0px 1px 8px rgba(160, 160, 160, 0)",
  "& > span": {
    display: "flex",
    flexDirection: "column",
  },
})

export const Box = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  marginLeft: "1rem",
})

export const BoxImage = styled("div")({
  height: "3.7rem",
  minWidth: "3.7rem",
  backgroundColor: "#618619",
  borderRadius: "50%",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
})

export const Image = styled("div")({
  width: "55%",
  marginBottom: "0.3rem",
  position: "absolute",
  color: "#FFF",
  fontSize: "100rem",
  height: "100%",
})

export const BoxInformations = styled("div")({
  display: "flex",
  flexDirection: "column",
  marginLeft: "0.5rem",
})

export const BoxTitle = styled("div")({
  fontFamily: "Inter",
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "1.1rem",
  lineHeight: "1.37rem",
  letterSpacing: "0.01em",
  color: "#353535",
})

export const BoxSubtitle = styled("div")({
  fontFamily: "Roboto",
  fontStyle: "normal",
  fontWeight: 400,
  fontSize: "1rem",
  lineHeight: "1.35rem",
  letterSpacing: "0.01em",
  color: "#757575",
})
